import { render, staticRenderFns } from "./PaoManagement.vue?vue&type=template&id=020b1326&scoped=true"
import script from "./PaoManagement.vue?vue&type=script&lang=js"
export * from "./PaoManagement.vue?vue&type=script&lang=js"
import style0 from "./PaoManagement.vue?vue&type=style&index=0&id=020b1326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020b1326",
  null
  
)

export default component.exports